import { Grid } from '@mantine/core';

export function MainColumn({ children }: { children: React.ReactNode }) {
  return (
    <Grid m={0} p={0} w="100%">
      <Grid.Col span={9}>{children}</Grid.Col>
    </Grid>
  );
}
